
import { createModel } from "@rematch/core";
import global from "global";
import request from "request";

const initialValue: global.contextApplication = {
	pending: true,
	data: null,
};

let pollingInterval: NodeJS.Timeout | null = null;


const application = createModel()({
	state: initialValue as global.contextApplication,

	reducers: {
		START_PENDING(state) {
			return { ...state, pending: true };
		},

		STOP_PENDING(state) {
			return { ...state, pending: false };
		},

		SET(state, payload: global.application) {
			if (JSON.stringify(state.data) === JSON.stringify(payload)) {
				return state;
			}

			return {
				...state,
				data: { ...payload },
			};
		},

		REMOVE() {
			return initialValue;
		},
	},

	effects: (dispatch) => ({
		async FETCH_APPLICATION_BY_ID(id?: string | number) {
			dispatch.application.START_PENDING();

			try {
				const response = await request.get("applications/" + id);
				const data = await response.data;

				dispatch.application.SET(data);

			} finally {
				dispatch.application.STOP_PENDING();
			}
		},

		START_POLLING(id?: string | number) {
			if (pollingInterval) {
				clearInterval(pollingInterval);
			}

			dispatch.application.FETCH_APPLICATION_BY_ID(id);

			pollingInterval = setInterval(() => {
				dispatch.application.FETCH_APPLICATION_BY_ID(id);
			}, 10000);
		},

		STOP_POLLING() {
			if (pollingInterval) {
				clearInterval(pollingInterval);
				pollingInterval = null;
			}
		},
	}),
});

export default application;
